import Module from '../../../module';
import scroll from '../../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsResourcesEscrowAgreementHeroContentSectionHeaderCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Resources Escrow Agreeement Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementHeroContentSectionHeaderCls || '', 'investors_resources_escrow_agreeement_hero', { animCls: 'animate__fadeInDown', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;